import { EChartsOption } from "echarts";
const color = ["rgba(255, 255, 255,0.3)", "rgba(255, 255, 255,0.0)"];
export const getChartsDefaultOptions = (
  redCircle: boolean,
  highlightAngle: number
) => {
  const isNegative = highlightAngle < 0;
  const absHighlightAngle = Math.abs(highlightAngle);

  const option = {
    animation: false,
    backgroundColor: "rgba(0,0,0,0.0)", // 背景颜色设置为透明
    xAxis: {
      show: false, // 不显示 x 轴
      min: -1,
      max: 1,
    },
    yAxis: {
      show: false, // 不显示 y 轴
      min: -1,
      max: 1,
    },
    grid: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
    series: [
      {
        name: "", // 系列名称
        type: "gauge", // 图表类型为仪表盘
        detail: false, // 不显示详情
        splitNumber: 20, // 刻度数量
        radius: "88%", // 图表尺寸，占父容器的 88%
        center: ["50%", "50%"], // 仪表盘中心位置
        startAngle: 0, // 开始刻度的角度
        endAngle: 360, // 结束刻度的角度
        min: 0,
        max: 360,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: true, // 显示刻度线
          lineStyle: {
            color: "#000", // 刻度线颜色
            width: 1, // 刻度线宽度
          },
          length: 10, // 刻度线长度
          splitNumber: 10, // 刻度线之间的间隔数
        },
        splitLine: {
          length: 15,
          lineStyle: {
            color: "#000", // 刻度线颜色
            width: 2, // 刻度线宽度
          },
        },
        axisLabel: {
          distance: -25,
          color: "#000",
          formatter: (value: number) => {
            return "";
          },
        },
      },
      {
        name: "圆点",
        type: "pie",
        z: 5,
        radius: "5%",
        center: ["50%", "50%"],
        data: [100],
        hoverAnimation: false,
        itemStyle: {
          normal: {
            color: redCircle ? "red" : "#000",
          },
        },
        labelLine: {
          show: false,
        },
        label: {
          show: false,
        },
      },
      {
        name: "圆圈1",
        type: "pie",
        z: 4,
        radius: ["15%", "18%"],
        center: ["50%", "50%"],
        data: [100],
        hoverAnimation: false,
        itemStyle: {
          normal: {
            color: "rgba(142, 150, 161,0.1)",
          },
        },
        labelLine: {
          show: false,
        },
        label: {
          show: false,
        },
      },
      {
        name: "圆圈2",
        type: "pie",
        z: 4,
        radius: ["40%", "43%"],
        center: ["50%", "50%"],
        data: [absHighlightAngle],
        hoverAnimation: false,
        itemStyle: {
          normal: {
            color: "rgba(142, 150, 161,0.1)",
          },
        },
        labelLine: {
          show: false,
        },
        label: {
          show: false,
        },
      },
      {
        name: "圆圈4",
        type: "pie",
        z: 4,
        radius: ["90%", "93%"],
        center: ["50%", "50%"],
        data: [absHighlightAngle],
        hoverAnimation: false,
        itemStyle: {
          normal: {
            color: "rgba(142, 150, 161,0.1)",
          },
        },
        labelLine: {
          show: false,
        },
        label: {
          show: false,
        },
      },
      {
        color: color,
        name: "圆圈3",
        type: "pie",
        radius: ["75%", "95%"],
        center: ["50%", "50%"],
        clockWise: isNegative ? true : false,
        data: [
          {
            value:
              absHighlightAngle >= 0
                ? absHighlightAngle
                : 360 - absHighlightAngle,
            name: `${Math.round(absHighlightAngle)}°`,
            label: {
              show: absHighlightAngle !== 0, // 当 highlightAngle 为 0 时隐藏标签
              position: "inner", // 负值时向左边绘制
              color: "#000", // 设置标签文字颜色，可以根据需要调整
              fontSize: 14, // 设置标签文字大小，可以根据需要调整
            },
            itemStyle: {
              normal: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(255,255,255,0.9)",
                borderWidth: absHighlightAngle !== 0 ? 2 : 0,
                borderColor: "#fff",
              },
            },
          },
          {
            value:
              absHighlightAngle >= 0
                ? 360 - absHighlightAngle
                : -absHighlightAngle,
            name: "",
            label: { show: false },
          },
        ],
        label: {
          normal: {
            rich: {
              font: {
                fontSize: 20,
                padding: [5, 0],
                color: "#fff",
              },
              hr: {
                height: 0,
                borderWidth: 1,
                width: "100%",
                borderColor: "#fff",
              },
            },
          },
        },
      },
    ],
  } as EChartsOption;

  return option;
};
